import oudImage from '../assets/oud.jpg';
import { motion } from "framer-motion";

function About() {
    const textVariants = {
      hidden: { opacity: 0, y: 20 },
      visible: { opacity: 1, y: 0 },
    };

    return (
      <section style={{ padding: "80px 20px", backgroundColor: "#fff", color: "#333" }}>
        <div style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          justifyContent: "space-between"
        }}>
          {/* Parfum Émirati */}
          <div style={{ flex: "1 1 45%" }}>
            <h2 style={{ marginBottom: "16px", fontSize: "24px", fontWeight: "bold" }}>PARFUMS EMIRATI</h2>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={textVariants}
              transition={{
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              style={{ opacity: 0 }} // Ajouté
            >
              La collection émirati de parfums pour homme et femme vous invite à découvrir l'essence même de Dubaï à travers des fragrances envoûtantes. Chaque parfum, inspiré des richesses culturelles et des paysages spectaculaires des Émirats, allie des notes orientales exquises à des touches florales et boisées. Des senteurs comme l'oud, le musc et la rose de Damas évoquent le luxe et la sophistication, faisant de chaque vaporisation une expérience olfactive unique. Que ce soit pour une occasion spéciale ou pour un usage quotidien, ces parfums incarnent l'élégance et le raffinement de la vie émiratie.
            </motion.p>
          </div>
        
          {/* Parfum Saudi */}
          <div style={{ flex: "1 1 45%" }}>
            <h2 style={{ marginBottom: "16px", fontSize: "24px", fontWeight: "bold" }}>PARFUMS SAUDI</h2>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={textVariants}
              transition={{
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1],
              }}
              style={{ opacity: 0 }} // Ajouté
            >
              Découvrez notre collection de parfums saoudiens, qui allie l'élégance intemporelle à des senteurs envoûtantes. Conçue pour hommes et femmes, cette gamme offre une expérience olfactive unique, inspirée des traditions riches d'Arabie Saoudite. Chaque fragrance a été soigneusement élaborée, utilisant des ingrédients de la plus haute qualité pour créer des compositions luxueuses et raffinées. Nos parfums se distinguent par leur profondeur et leur richesse, surpassant les créations émiraties par leur intensité et leur caractère. Laissez-vous séduire par ces créations exceptionnelles qui célèbrent l'art de la parfumerie saoudienne.
            </motion.p>
          </div>
        </div>

        {/* Image centrée en dessous */}
        <div style={{ textAlign: "center", marginTop: "60px" }}>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={{
              hidden: { opacity: 0, scale: 0.9 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.8,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            style={{
              width: "100%",
              maxWidth: "1200px",
              aspectRatio: "16/6",
              margin: "0 auto",
              overflow: "hidden",
              borderRadius: "20px",
              background: "#eee",
            }}
          >
            <img
              src={oudImage}
              alt="gold and black trophy on glass table"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "20px",
                display: "block",
              }}
            />
          </motion.div>
        </div>
      </section>
    );
}

export default About;